import styled, { css } from 'styled-components';

import { whiteLabelingConfig } from '@/utils/whiteLabeling';

interface WrapperProps {
  notMinify?: boolean;
  horizontalMode?: boolean;
}

export const Wrapper = styled.button<WrapperProps>`
  border: none;
  background-color: transparent;
  margin-bottom: ${({ theme, horizontalMode }) => (horizontalMode ? '0px' : theme.spacings.spacing16)};
  display: flex;
  flex-direction: row;

  ${({ theme, notMinify }) => {
    if(whiteLabelingConfig?.isSidebarItemWide && notMinify) {
      return css`
      margin-top: ${theme.spacings.s};
        margin-left: ${theme.spacings.l}
      `;
    }
    
  }}
  /* margin-left: ${({ theme, notMinify }) => (notMinify ? `${theme.spacings.spacing6}` : '0')}; */
 
`;
export default Wrapper;
